import React, {useEffect, useMemo} from "react";
import {Modal, Table} from "react-bootstrap";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import {ModalProgressBar} from "../../../../_metronic/_partials/controls";
import * as formatter from "../../../../utils/formatter";
import * as actions from "../../../../redux/modules/links/actions";
import {NoRecordsFoundMessage, PleaseWaitMessage} from "../../../../_metronic/_helpers";
import {SALES_STATUS} from "../../../../utils/codes";
import {columns} from "./ui.helpers";

const isProd = process.env.NODE_ENV === 'production';
const APP_URL = isProd ? 'https://lullu.app' : 'http://localhost:3000';

export function LinkDetailModal({show, onHide, linkId}) {
  const dispatch = useDispatch();

  const { isLoading, link } = useSelector(
    ({links}) => ({
      isLoading: links.actionsLoading,
      isSellersLoading: links.sellersLoading,
      link: links.link,
      sellerList: links.sellerList,
      sellerCount: links.sellerCount,
    }),
    shallowEqual,
  );

  const format = useMemo(() => ({
    DotFormatter: formatter.dot(SALES_STATUS),
    ArrayFormatter: formatter.join(" > "),
    DateFormatter: formatter.dateTime,
    PriceFormatter: formatter.price,
    CountFormatter: formatter.count,
    calcFormatter: formatter.calculator((a, b) => Math.round(a * b / 100)),
  }), []);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  useEffect(() => {
    if (linkId) {
      dispatch(actions.fetchLink(linkId));
    }
  }, [linkId, dispatch]);

  if (!link) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      aria-labelledby="example-modal-sizes-title-lg"
      centered
    >
      {isLoading && <ModalProgressBar/>}
      <Modal.Header>
        <div>
          <h3>판매 링크 상세</h3>
          <span className="text-dark-50">판매파트너가 등록한 판매 링크 상세 정보를 확인하세요.</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Table responsive borderless>
          <tbody>
          <tr>
            <th>판매 상태</th>
            <td colSpan={3}>{format.DotFormatter(link.saleSttsCd)}</td>
          </tr>
          <tr>
            <th>링크 코드</th>
            <td>{link.saleNo}</td>
            <th>판매 등록일시</th>
            <td>{format.DateFormatter(link.regDtime)}</td>
          </tr>
          <tr>
            <th>누적 주문 건수</th>
            <td>{format.CountFormatter(link.totSaleCnt)}</td>
            <th>누적 판매 금액</th>
            <td>{format.PriceFormatter(link.totSaleAmt)}</td>
          </tr>
          <tr>
            <th>판매 링크 URL</th>
            <td colSpan={3}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`${APP_URL}/cart/${link.saleNo}/${link.goodsList[0].goodsNo}`}
              >
                {`${APP_URL}/cart/${link.saleNo}/${link.goodsList[0].goodsNo}`}
              </a>
            </td>
          </tr>
          </tbody>
        </Table>

        {link.goodsList && (
          <div className="mt-7 px-3">
            <p className="font-weight-boldest text-primary mb-5">
              판매 상품
            </p>
            <BootstrapTable
              remote
              bootstrap4
              keyField="id"
              bordered
              columns={columns}
              wrapperClasses="table-responsive"
              classes="table table-head-bg table-vertical-center overflow-hidden table-responsible"
              data={link.goodsList}
            >
              <PleaseWaitMessage entities={link.goodsList}/>
              <NoRecordsFoundMessage entities={link.goodsList}/>
            </BootstrapTable>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <div>
          <button type="button" className="btn btn-dark btn-elevate w-130px" onClick={onHide}>
            확인
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
